import React, {useContext, useEffect, useState} from "react";
import axios from 'axios'
import {GlobalContext} from "../../contexts/context";
import {initState} from "../../contexts/initState";

export const useGetJobs = () => {
    const context = useContext(GlobalContext);
    const [loading, setLoading] = useState(false);
    const [content, setContent] = useState({data: []});
    let mounted = true;
    const handleGetJobs = async () => {
        setLoading(true);
        try {
            // Swap these when we release
            let data;
            if(process.env.NODE_ENV === "development"){
                data = await axios.get("https://testes420.s3.amazonaws.com/data1.json")
                //const data = await axios.get("https://testes420.s3.amazonaws.com/emptydata.json")
            } else
                data = await axios.get(`${context.applicationState.apiUrl}/api/getRPAStatus.aspx?version=2`, {withCredentials: true});

            if (mounted) {
                if (data.status === 200) {
                    if (data.data.rows) {
                        setContent({
                            data: data.data.rows,
                            message: "Fetched rpas successful",
                            hasError: false
                        });
                    } else {
                        setContent({
                            data: [],
                            message: data.data,
                            hasError: true
                        });
                        // likely an authentication error, redirect to login
                        window.location.href = `${window.location.origin}/login`;
                        console.log("error, saving local state")
                        context.saveLocalState("user", {
                            ...initState.user
                        })
                    }
                } else {
                    setContent({
                        data: [],
                        message: "An unknown error occurred while attempting to fetch rpas.",
                        hasError: true
                    })
                }
                setLoading(false)
            }
        } catch(err){
            setContent({
                data: [],
                message: "An unknown error occurred while attempting to fetch rpas.",
                hasError: true
            });
            setLoading(false)
            // likely an authentication error, redirect to login
            window.location.href = `${window.location.origin}/login`;
            console.log("error, saving local state")
            context.saveLocalState("user", {
                ...initState.user
            })
        }
    };

    useEffect(() => {
        return () => {
            mounted = false;
        };
    }, []);

    return {loading, content, handleGetJobs};
};
